import dynamic from "next/dynamic";
import { Brand, ThemeProvider } from "@/core/types/types";
import { Theme } from "@mui/material";

declare module "@mui/material/styles" {
  interface PaletteOptions {
    layout?: {
      background: string;
      color: string;
    };
    progress?: {
      complete: string;
    };
  }
}

export type ExtendedTheme = Theme & {
  palette: {
    layout: {
      background: string;
      color: string;
    };
    progress?: {
      complete: string;
    };
  };
};

const DynamicThemeProviders: ThemeProvider = {
  [Brand.DEFAULT]: dynamic(() => import("./FlightrightTheme")),
  [Brand.FLIGHTRIGHT]: dynamic(() => import("./FlightrightTheme")),
  [Brand.FLUGRECHT]: dynamic(() => import("./FlugrechtTheme")),
  [Brand.FLYHJELP]: dynamic(() => import("./NordicFamilyTheme")),
  [Brand.FLYGHJALP]: dynamic(() => import("./NordicFamilyTheme")),
  [Brand.FLYHJAELP]: dynamic(() => import("./NordicFamilyTheme")),
  [Brand.LENTOAPU]: dynamic(() => import("./NordicFamilyTheme")),
  [Brand.REFUNDMORE]: dynamic(() => import("./NordicFamilyTheme")),
  [Brand.ALLRIGHT]: dynamic(() => import("./AllrightTheme")),
  [Brand.CHEVALIER]: dynamic(() => import("./ChevalierTheme")),
};

export default DynamicThemeProviders;
